<div *ngFor="let option of affiliationSettings.AffCodeOptions">
  <div class="col-sm-6" *ngIf="option.Visible">
    <label>
      {{ option.LabelText ? option.LabelText : option.Name }}
    </label>
  </div>
</div>
